import highlightBoxApi from "../api/highlight-box-api";

const add = async (payload) => {
    const resp = await highlightBoxApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await highlightBoxApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await highlightBoxApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await highlightBoxApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const saveDisplay = async (payload) => {
    const resp = await highlightBoxApi.saveDisplay(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const getDisplay = async (payload) => {
    const resp = await highlightBoxApi.getDisplay(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const highlightBoxService = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
};

export default highlightBoxService;